import React, {Component} from 'react';

import ReactHighcharts from 'react-highcharts';
import Divider from '@material-ui/core/Divider';

import './styles.scss';


export default class BarChart extends Component {

    _getGraphConfig = () => {
        return {
            chart: {
                type: 'bar',
                height: 100,
                marginRight: 70,
                // paddingRight:150,
                animation: false
            },
            title: {
                text: ''
            },
            xAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                categories: ['Semana', 'Fin de semana'],
            },
            yAxis: {
                min: 0,
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                title: {
                    text: '',
                },
                labels: {
                    enabled: false,
                },
                stackLabels: {
                    x: 0,
                    enabled: true,
                    format: '{total:.0f}',
                    style: {
                        color: 'black',
                    }
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                pointFormat: '<b>{point.y:.0f}</b>'
            },
            plotOptions: {
                series: {
                    stacking: 'percent',
                    pointWidth: 10,
                    stackLabels: {
                        enabled: true,
                        align: 'right',
                        color: '#FFFFFF'
                    },

                }
            },
            credits: {
                enabled: false
            },
            series: this.props.data
        };
    }


    render() {

        let graph_config = this._getGraphConfig();
        return (
            <div style={{width: '100%', marginLeft: 20}}>
                <div className={"turn"}>
                    <div style={{backgroundColor:'#F8F8F8', width:80}}>
                        <div className={"image-div"}>
                            <img src={this.props.img} style={{height:this.props.height?24:15}} alt={"time-of-day"} className={"image"}/>
                        </div>
                        <div className={"time"}>
                            {this.props.turn}
                        </div>
                    </div>
                    <div className={"highchart"}>
                        <ReactHighcharts config={graph_config}/>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/performancePerTurn/components/barChart/BarChart.js